import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { db } from './api/db';

import Layout from './components/layout/Layout';
import Home from './pages/Home';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import Links from './pages/Links';
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import Media from './pages/admin/Media';
import ArticleEditor from './pages/admin/ArticleEditor';
import ManageUsers from './pages/admin/ManageUsers';
import SiteSettings from './pages/admin/SiteSettings';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  
  return children;
};

const AppRoutes = () => {
  useEffect(() => {
    // Initialize mock database
    db.init();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="links" element={<Links />} />
        <Route path="blog" element={<BlogList />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="login" element={<Login />} />
        
        {/* Protected Admin Routes */}
        <Route path="admin" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="admin/media" element={
          <ProtectedRoute>
            <Media />
          </ProtectedRoute>
        } />
        <Route path="admin/editor/:id" element={
          <ProtectedRoute>
            <ArticleEditor />
          </ProtectedRoute>
        } />
        <Route path="admin/users" element={
          <ProtectedRoute>
            <ManageUsers />
          </ProtectedRoute>
        } />
        <Route path="admin/settings" element={
          <ProtectedRoute>
            <SiteSettings />
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <HashRouter>
          <AppRoutes />
        </HashRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;